// extracted by mini-css-extract-plugin
export default {"container":"SectionTitle_container__yrwkn","title":"SectionTitle_title__VTshV","number":"SectionTitle_number__JldOa"};